import oRequest from '@/libsV2/request.js';

const URL = {
    MEMBER_PROJECT_MAPPING: 'member/project/mapping', // 勘察报告
}

export const getMapping = (data = {}) => {
    return oRequest.getData(URL.MEMBER_PROJECT_MAPPING, data);
};